export default "__VITE_ASSET__jjwc_M$a__"